import { render, staticRenderFns } from "./Airing.vue?vue&type=template&id=3311daf4"
import script from "./Airing.vue?vue&type=script&lang=js"
export * from "./Airing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports